import { render, staticRenderFns } from "./SetPromotionBannerTable.vue?vue&type=template&id=b827a39e&scoped=true"
import script from "./SetPromotionBannerTable.vue?vue&type=script&lang=js"
export * from "./SetPromotionBannerTable.vue?vue&type=script&lang=js"
import style0 from "./SetPromotionBannerTable.vue?vue&type=style&index=0&id=b827a39e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b827a39e",
  null
  
)

export default component.exports